import type { ComponentPropsWithRef, ReactNode } from 'react';

import { styles } from './styles';

import { tv } from '@simplywallst/ui-core/next';

import { NumericInput } from './NumericInput';

const textField = tv({
  extend: styles,
});

type Props = ComponentPropsWithRef<typeof NumericInput> & {
  label?: string;
  error?: string | null;
  isDisabled?: boolean;
  /**
   * Add an element at the start of the Input.
   *
   * Can be used to add a descriptive Icon or extra information adornment, such as measurement unit.
   */
  prefix?: ReactNode;
};

export const NumericField = ({
  label,
  error,
  isDisabled,
  prefix,
  className,
  ...rest
}: Props) => {
  const hasError = error !== undefined && error !== '' && error !== null;

  const styles = textField({
    isDisabled,
    hasError,
  });

  return (
    <fieldset
      data-invalid={hasError}
      className={styles.fieldset({ className })}
    >
      {typeof label !== 'undefined' && (
        <label className={styles.label()}>{label}</label>
      )}
      <div data-prefix={prefix !== undefined} className={styles.input()}>
        {prefix !== undefined && (
          <span className={styles.inputPrefix()}>{prefix}</span>
        )}
        <NumericInput
          disabled={isDisabled}
          className={styles.inputEl()}
          {...rest}
        />
      </div>
      {hasError && <span className={styles.error()}>{error}</span>}
    </fieldset>
  );
};
